import { render, staticRenderFns } from "./indecatorMenu.vue?vue&type=template&id=39927c27&"
import script from "./indecatorMenu.vue?vue&type=script&lang=js&"
export * from "./indecatorMenu.vue?vue&type=script&lang=js&"
import style0 from "./indecatorMenu.vue?vue&type=style&index=0&id=39927c27&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports